<template>
  <div class="ma-5 black--text">
    <!-- <AppBar :tribe="tribe" /> -->
    <div :class="!$isMobile ? 'mx-2 center':''">
      <img v-if="avatarImage" :src="hackURL(tribe?.avatarImage?.uri)" class="logo" />
      <h1>
        {{ tribe.preferredName }}
      </h1>
      <h2 class="py-4">registration form successfully sent</h2>
      <p class="overline">Ngā mihi</p>
    </div>
  </div>
</template>

<script>
const hackURL = require('@/lib/hack-url.js')

export default {
  name: 'RegistrationSuccess',
  data: () => ({
    emailSent: false
  }),
  apollo: {
  },
  computed: {
    tribe () {
      return this.$route.params.tribe
    },
    person () {
      return this.$route.params.input
    },
    avatarImage () {
      return this.tribe.avatarImage ? this.tribe.avatarImage.uri : null
    }
  },
  methods: {
    hackURL
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  // background-color: white;
  width: 100%;
  height: 100%;
  max-width: 1600px;
  margin: auto;
}
h1 {
  font-size: 1.5em;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 5px;
}
h2 {
  font-size: 1em;
  text-transform: uppercase;
  font-weight: 400;
  letter-spacing: 4px;
}
.avatarImage {
  height: 100px;
  padding: 0 25px;
}
.center {
  text-align: center;
  margin-top: 20%;
}

</style>
